import React from 'react';
import { Link } from 'react-router-dom';
import { AlertCircle, Home, Grid, LifeBuoy } from 'lucide-react';
import { useI18n } from '../context/I18nContext';
import { SeoHead } from '../components/common/SeoHead';
import { Button } from '../components/ui/Button';

export interface NotFoundPageProps {
  customMessage?: string;
}

export const NotFoundPage: React.FC<NotFoundPageProps> = ({ customMessage }) => {
  const { t } = useI18n();

  return (
    <div className="py-20 sm:py-32 max-w-2xl mx-auto px-4 sm:px-6 text-center space-y-8">
      <SeoHead
        title="페이지를 찾을 수 없습니다 (404 Not Found)"
        description="요청하신 페이지가 존재하지 않거나 주소가 변경되었습니다."
      />

      <div className="w-16 h-16 rounded-2xl bg-amber-50 text-amber-600 border border-amber-200 mx-auto flex items-center justify-center">
        <AlertCircle className="w-8 h-8" />
      </div>

      <div className="space-y-3">
        <span className="text-xs font-mono font-bold text-slate-400 uppercase tracking-widest">
          404 Not Found
        </span>
        <h1 className="text-3xl sm:text-4xl font-extrabold text-slate-900 tracking-tight">
          {customMessage || t.common.notFoundTitle}
        </h1>
        <p className="text-base text-slate-600 max-w-md mx-auto">
          {t.common.notFoundDesc} 입력하신 주소가 올바른지 다시 한번 확인해 주세요.
        </p>
      </div>

      <div className="flex flex-col sm:flex-row items-center justify-center gap-3 pt-4">
        <Link to="/" className="w-full sm:w-auto">
          <Button variant="primary" size="md" fullWidth icon={<Home className="w-4 h-4" />}>
            {t.common.backHome}
          </Button>
        </Link>
        <Link to="/apps" className="w-full sm:w-auto">
          <Button variant="outline" size="md" fullWidth icon={<Grid className="w-4 h-4" />}>
            {t.nav.apps}
          </Button>
        </Link>
        <Link to="/support" className="w-full sm:w-auto">
          <Button variant="secondary" size="md" fullWidth icon={<LifeBuoy className="w-4 h-4" />}>
            {t.nav.support}
          </Button>
        </Link>
      </div>
    </div>
  );
};
